export default __webpack_public_path__ + "static/media/pic4.4db043e4.jpg";